import { GetterTree } from 'vuex';
import { RecommendationsState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { InfiniteScrollEnabledGetter } from './getters/infinite-scroll-enabled.getter';
import { TopRecommendationsGetter } from './getters/top-recommendations.getter';

export const RECOMMENDATIONS_GETTERS: GetterTree<RecommendationsState, RootStoreState> = {
  ...new InfiniteScrollEnabledGetter().getters,
  ...new TopRecommendationsGetter().getters
};
